export default {
  addItem: {
    position: 'absolute',
    right: 200,
    top: 35,
    zIndex: 1,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  nameCol: {
    width: 200,
  },
  itemsCol: {},
  actionCol: {
    width: 150,
  },
  chip: {
    // margin: 3,
  },
  itemTypes: {
    display: 'flex',
  },
  badge: {
    // zIndex: 1000,
    padding: 5,
  },
  badgeContainer: {
    padding: 9,
  },
};



// WEBPACK FOOTER //
// ./src/components/Admin/Printers/PrintersView/styles.js